import { mapActions, mapGetters } from 'vuex'
import AxoftSOFL from '@assets/img/AxoftSOFL.svg?inline'

export default {
  components: {
    'axoft-sofl-svg': AxoftSOFL,
  },
  data() {
    return {}
  },
  computed: {
    ...mapGetters('lk', ['linkAuth']),
  },
  methods: {
    ...mapActions('modal', ['modalType_fullVersionOpen', 'modalClose']),
  },
}



// WEBPACK FOOTER //
// ./src/templates/components/ui-components/banner-btn/component.js